import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
    palette: {
      mode: "light",
      primary: {
        main: "#367C2B",
      },
      secondary: {
        main: "#FFDE00",
      },
      success: {
        main: "#66bb6a",
      },
      error: {
        main: "#f44336",
      },
      info: {
        main: "#708090",
      },
      background: {
        default: "#ffffff",
      },
    },
  });